import React, { ChangeEvent } from "react";

import ModalDialog, { IModalDialogBaseProps } from "./ModalDialog";

import { V2 } from "../../Api";

import "../../form.css";

interface IVehicleUpdateMileageDialogProps extends IModalDialogBaseProps {
    vehicle: any;
}

interface IVehicleUpdateMileageDialogState {
    submitStatus: boolean | string;

    date: string;
    mileage: string;
}

class VehicleUpdateMileageDialog extends React.Component<IVehicleUpdateMileageDialogProps, IVehicleUpdateMileageDialogState> {
    constructor(props: Readonly<IVehicleUpdateMileageDialogProps>) {
        super(props);

        this.state = {
            submitStatus: false,
            date: "",
            mileage: "",
        };

        this.submit = this.submit.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<IVehicleUpdateMileageDialogProps>) {
        if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
            // Clear fields
            this.setState({
                date: "",
                mileage: "",
            });
        }
    }

    public render() {
        const { isOpen, onRequestClose } = this.props;
        return <ModalDialog isOpen={isOpen} onRequestClose={onRequestClose} className="modal-500px" title="Update mileage">
            <div className="input-form">
                <div className="info-block">
                    <section>
                        <div className="input-form-group">
                            <div>Update mileage for <b>{this.props.vehicle.name} {this.props.vehicle?.color || ""} ({this.props.vehicle?.tag || "No tag"})</b></div>
                        </div>
                    </section>
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="frm-date" className="required">Date</label>
                            <input type="date" id="frm-date" name="date" value={this.state.date} onChange={this.handleInputChanged} />
                        </div>
                        <div className="input-form-group">
                            <label htmlFor="frm-mileage" className="required">Mileage</label>
                            <input type="number" id="frm-cost" name="mileage" step={0.01} min={0.00} value={this.state.mileage} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                    &nbsp;
                    {this.state.submitStatus === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.submitStatus === "string"
                            ? <div className="error-text">{this.state.submitStatus}</div>
                            : null
                    }
                    <div className="action-panel-dialog">
                        <button type="button" className="button push-right text-with-icon" onClick={this.submit}><i className="icon-check" /><span>Save</span></button>
                    </div>
                </div>
            </div>
        </ModalDialog>;
    }

    private async submit() {
        try {
            this.setState({
                submitStatus: true
            });

            if (!this.state.date) {
                throw new Error("Date must not be empty");
            }
            if (!this.state.mileage) {
                throw new Error("Mileage must not be empty");
            }

            const data = {
                date: this.state.date,
                mileage: this.state.mileage
            };

            await V2.post(`vehicles/${this.props.vehicle.id}/mileage`, data);

            this.setState({
                submitStatus: false
            });

            this.props.onRequestClose(true);
        }
        catch (e) {
            this.setState({
                submitStatus: e.message || "Failed to submit"
            });
        }
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLTextAreaElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }
}

export default VehicleUpdateMileageDialog;
